import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Table = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Table' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M8,5 L8,23 M16,5 L16,23 M1,11 L23,11 M1,5 L23,5 M1,17 L23,17 M1,1 L23,1 L23,23 L1,23 L1,1 Z' />
  </StyledIcon>
);
